require("!!/usr/app/node_modules/script-loader/addScript.js")(require("!!/usr/app/node_modules/raw-loader/index.js!/usr/app/node_modules/photoswipe/dist/photoswipe-ui-default.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/photoswipe/dist/photoswipe-ui-default.js
// module id = 31
// module chunks = 2